import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import CheckCircle from "@material-ui/icons/CheckCircle"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  },
}))

export default function SimpleAccordion(props) {
  const defaultNumItems = 5
  const classes = useStyles()
  const [numOfItems, setNumOfItems] = useState(defaultNumItems)
  const accordion = props.items.map((item, i) =>
    typeof item !== "string" ? (
      <Accordion
        key={i}
        className={i > numOfItems ? "hidden" : ""}
        classes={{ expanded: "large-shadow" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className="flex justify-center items-center">
            <CheckCircle className="mr-2 text-red" />
            <p className="text-lg font-semibold text-blue">{item.name}</p>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="text-gray-500">{item.description}</Typography>
        </AccordionDetails>
      </Accordion>
    ) : (
      <Accordion
        disabled
        key={i}
        className={i > numOfItems ? "hidden" : ""}
        classes={{ disabled: "white-bg" }}
      >
        <AccordionSummary
          expandIcon={false}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{ disabled: "white-bg" }}
        >
          <Typography className="flex items-center justify-center">
            <CheckCircle className="mr-2 text-red" />
            <p className="text-lg font-semibold text-blue">{item}</p>
          </Typography>
        </AccordionSummary>
      </Accordion>
    )
  )
  const handleClick = () => {
    setNumOfItems(prevState => {
      if (prevState > defaultNumItems) return defaultNumItems
      return props.items.length
    })
  }

  return (
    <>
      <div className={classes.root + " shadow-lg"}>{accordion}</div>{" "}
      {props.items.length > defaultNumItems && (
        <button
          onClick={handleClick}
          className="block px-4 py-2 mx-auto border-2 bottom-4 hover:border-blue transition duration-300 ease-out hover:text-blue border-red text-blue"
        >
          {numOfItems === defaultNumItems ? "Load More" : "Load Less"}
        </button>
      )}
    </>
  )
}
